import infoImage1 from '../images/mini_portal/Community/info1.png'
import infoImage2 from '../images/mini_portal/Community/info2.png'
import infoImage3 from '../images/mini_portal/Community/info3.png'
import infoImage4 from '../images/mini_portal/Community/info4.png'
import infoImage5 from '../images/mini_portal/Community/info5.png'
import infoImage6 from '../images/mini_portal/Community/info6.png'
import infoImage7 from '../images/mini_portal/Community/info7.png'
import infoImage8 from '../images/mini_portal/Community/info8.png'
import infoImage9 from '../images/mini_portal/Community/info9.png'
import infoImage10 from '../images/mini_portal/Community/info10.png'
import infoImage11 from '../images/mini_portal/Community/info11.png'
import infoImage12 from '../images/mini_portal/Community/info12.png'
import infoImage13 from '../images/mini_portal/Community/info13.png'
import infoImage14 from '../images/mini_portal/Community/info14.png'
import phone from '../images/mini_portal/phone@2x.png'
import phone1 from '../images/mini_portal/connect/slide-02@2x.png'
import mobilePhone1 from '../images/mini_portal/connect/mobile-phone1.png'
import mobilePhone2 from '../images/mini_portal/connect/mobile-phone2.png'
import mobilePhone3 from '../images/mini_portal/connect/mobile-phone3.png'
import mobilePhone4 from '../images/mini_portal/connect/mobile-phone5.png'
import mobilePhone5 from '../images/mini_portal/connect/mobile-phone4.png'
import mobilePhone6 from '../images/mini_portal/connect/mobile-phone6.png'
import group2 from '../images/mini_portal/connect/group-3-copy-2.png'
import group3 from '../images/mini_portal/connect/group-3@2x.png'
import group4 from '../images/mini_portal/connect/card-15@2x.png'
import group5 from '../images/mini_portal/connect/claims-copy@2x.png'
import group7 from '../images/mini_portal/connect/claims@2x.png'
import group8 from '../images/mini_portal/connect/tasks@2x.png'

export const infoList1 = [{
    id: '1',
    image: infoImage1,
    title: 'Special Interest Groups',
    description: 'No more dozens of WhatsApp groups to track and manage. Create,' +
    ' publish, find and connect with all your special interest groups in one place. Be within the larger scope of your community & in parallel,' +
    ' within your small & yet very focussed interest groups, that is most relevant.'
}, {
    id: '2',
    image: infoImage2,
    title: 'Events / Workshop',
    description: 'Large or small, restricted or public - manage events like a pro. Create and share event agenda.' +
    ' Members mark their attendance with the check-in feature - you get the attendee list in real time. Also digitize event feedback right here on Hubbler.'
}, {
    id: '3',
    image: infoImage3,
    title: 'Members Directory',
    description: 'Find any fellow global or local Member based on Profile, Industry, Skills or Location. When you are travelling, the app will show the members nearest to your location. In a click, you can connect with your community members who are closer to your current location. You can choose to contact them by looking at their profile information.' +
    ' Networking has never been easier!'
}, {
    id: '4',
    image: infoImage4,
    title: 'Profile',
    description: 'Get to know the members. From their business, to the industries, skills, interest,  learning needs and family. Been just smiling or saying hello? Get from being acquaintances to friends. Profile information helps you connect with like minded members & network better for a mutual benefit or for business connects.'
}]

export const infoList2 = [{
    id: '1',
    image: infoImage5,
    title: 'Renew Reminder',
    description: 'Create polls, get peer opinions on issues that matter to you without needing to send out a ton of mails.'
},
    {
        id: '2',
        image: infoImage6,
        title: 'User Onboarding',
        description: 'Everything on your ballot, in your mobile! From administrative measures to ballot measures to voting rights, access everything on your entire ballot that you\'ll see in the voting booth.'
    },
    {
        id: '3',
        image: infoImage7,
        title: 'Polls',
        description: 'Create polls, get peer opinions on issues that matter to you without needing to send out a ton of mails.'
    },
    {
        id: '4',
        image: infoImage8,
        title: 'Marketplace',
        description: 'This is where you get what Alexa & Siri flounder to give you. Reach out to your peers when you need something or you wish to share something.'
    },
    {
        id: '5',
        image: infoImage9,
        title: 'Benefits & Alliances',
        description: 'Never miss out on a deal or an opportunity which otherwise gets lost in mountains of mails and messages. Sponsors, deals, opportunities - global or local - all are here waiting for you to notice them.'
    },
    {
        id: '6',
        image: infoImage10,
        title: 'Vote',
        description: 'Everything on your ballot, in your mobile! From administrative measures to ballot measures to voting rights, access everything on your entire ballot that you\'ll see in the voting booth.'
    },
    {
        id: '7',
        image: infoImage11,
        title: 'Global Community',
        description: 'The best part of Hubbler Connect is the Global Platform that it is. This platform is ready to integrate your worldwide network and connect the large community through this trestle.'
    },
    {
        id: '8',
        image: infoImage12,
        title: 'Sponsored Channels',
        description: 'Communities can have sponsorship channels, wherein they share deals, offers, new launches, etc. for the members consumption.'
    },
    {
        id: '9',
        image: infoImage13,
        title: 'Library',
        description: 'Whether your employees are avid book readers, magazine readers, or newspaper readers; You can put 100s of e-books at their fingertips!'
    },
    {
        id: '10',
        image: infoImage14,
        title: 'Channels',
        description: 'Channels allow communities to share announcements, updates,etc. Channels could also be created by members for other members to be updated based upon their common interests, passion.'
    }]

export const communityWebViewData = [{
    id: '1',
    image: phone,
    text: ['Quick access to favourite apps', 'Find an event of your interest, happening around you, whether at home or travelling.', 'See the data that matters', 'Celebrate successes and milestones - yours and your fellow Community members!\n' +
    '                            Latest updates on your Chapter members and others whom you follow ']
}, {
    id: '2',
    image: phone1,
    text: ['Welcome the new members. Get to know them', '', '', 'Birthday / Anniversary Alerts\n' +
    'Wish on time - every time']
}]

export const communityMobileViewData = [{id: '1', image: mobilePhone1, name: 'Quick access to favourite apps'},
    {id: '2', image: mobilePhone2, name: 'See the data that matters'},
    {
        id: '3',
        image: mobilePhone3,
        name: 'Find an event of your interest, happening around you, whether at home or travelling.'
    },
    {
        id: '4',
        image: mobilePhone4,
        name: 'Celebrate successes and milestones - yours and your fellow Community members!'
    }, {id: '5', image: mobilePhone5, name: 'Welcome the new members. Get to know them'}, {
        id: '6', image: mobilePhone6, name: 'Birthday / Anniversary Alerts\n' +
        'Wish on time - every time'
    }]

export const dashboardData = [{
    id: '1',
    name: 'Members Insight',
    discription: 'More from the Core. We have built tools that will throw up information about your chapter’s activities and provide you with insight about events, SIG and member integration. Know the member interests, participation numbers etc.. Measure everything that was previously immeasurable & get into the details from an impact measure in real time & get periodic KPI’s in your inbox.',
    images: [group2, group3, group4]
},
    {
        id: '2',
        name: 'Admin Insight',
        discription: 'Who doesn\'t wish to manage their operational affairs better! Let Hubbler assist you in giving you insights on your events, be it knowing the most popular to the best ranked speakers. All insights are drill down for multi-level details.',
        images: [group5, group7, group8]
    }
]



// WEBPACK FOOTER //
// ./src/data/community-engagement.js